"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * REGEXP patterns for validation
 */
var _default = {
  //TODO, Very simple email validation
  EMAIL: "^[A-Za-z0-9._%+'-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,20}$",
  //TODO, MESSY, rethink this w/ a better apporach, maybe a custom keyword with different rexexp patterns (NA, Europe, etc)
  PHONE: "^(?:(?=.{7,40}$)(?:[0-9]{7,}(x[0-9]+)?))?$",
  // TODO need to add '_' to this regex to support '_HVHT' in the programName
  LEGACY_PROGRAM_NAME: "^[A-Za-z0-9-_]{2,75}_MKTO$",
  ONE_MKTO_PROGRAM_NAME: "^[A-Za-z0-9-_]{2,80}$",
  DATE: "^(20[1,2][0-9])-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$",
  PARTNER_ID: "^\\d{1,20}$",
  SOURCE: "^[Mm][Aa][Rr][Tt][Ee][Ll]\\s+[Ss][Ll][Uu][Gg]:\\s+\\[?[A-Za-z0-9-]+\\]?$",
  TRUE: "^[Tt][Rr][Uu][Ee]$",
  NUMBER_OF_EMPLOYEES_GLOBAL: "^$|^[1-9]\\d{0,5}$",
  TRUE_OR_FALSE: "(^\\s*$|^([Tt][Rr][Uu][Ee]|[Ff][Aa][Ll][Ss][Ee])$)"
};
exports.default = _default;
//# sourceMappingURL=Patterns.js.map